<template>
  <div class="ibox row">
    <div class="ibox-title" v-if="hasSlot('title')">
      <slot name="title"></slot>
    </div>
    <div class="ibox-content" v-if="hasSlot('content')">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    hasSlot (name) {
      return !!this.$slots[name]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Inspinia/Ibox.vue